export default "__VITE_ASSET__BJ5IwZMx__"